export const LoginSuccess = "noticeSignInSuccess";
export const SignUpSuccess = "noticeSignUpSuccess";
export const SessionExpired = "noticeSessionExpired";
export const LoginFailed = "noticeLoginFailed";
export const LinkDeviceFailed = "noticeLinkDeviceFailed";
export const LinkPolygonFailed = "noticeLinkPolygonFailed";
export const PasswordNotSame = "noticePasswordNotSame";
export const FieldIsMandatory = "noticeMandatory";
export const FieldIsNotValid = "noticeNotValid";
